import { useContextState } from '../../../../../../hooks/theme'
import { SxGeneral } from '../../../../../../utils/types/generals'

const useStyles = (): SxGeneral => {
  const { colors } = useContextState()
  return {
    stepsIndicatorContainer: {
      marginTop: '10px',
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      columnGap: '5px',
      '& .MuiPaginationItem-root': {
        margin: '0px'
      }
    },
    documentsContainer: {
        width: '100%',
        maxHeight: '200px',
        overflowY: 'auto',
        padding: '3px',
        display: 'flex',
        flexWrap: 'wrap',
        rowGap: '10px',
        backgroundColor: 'white',
        borderBottom: `1px solid ${colors.color13}`
    },
    documentItems: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        padding: '10px 10px 0px',
        borderRadius: '5px',
        '&:hover': {
            backgroundColor: `${colors.color22}05`,
        },
        '& .MuiIcon-root': {
            color: colors.color1,
            height: '35px',
            width: '35px',
        },
    },
    comments: {
      width: '100%',
      maxHeight: '300px',
      overflowY: 'auto',
      paddingTop: '10px'
    },
    videos: {
      width: '100%',
      height: '100px',
      position: 'relative',
      '& video': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      margin: '0px'
    },
    images: {
      width: '100%',
      height: '100px',
      position: 'relative',
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      margin: '0px'
    },
    expand: {
      position: 'absolute',
      bottom: '5px',
      right: '5px',
      color: colors.color5,
      backgroundColor: '#00000022',
      fontSize: '25px',
      width: '30px',
      height: '30px',
      '& .MuiSvgIcon-root': {
        fontSize: 'inherit',
        width: 'inherit',
        height: 'inherit'
      }
    },
    container: {
      '& .MuiAccordionDetails-root': {
        maxHeight: '270px',
        overflow: 'auto',
      },
      '& .MuiAccordionSummary-root': {
        boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
        borderRadius: '8px'
      },
      '& .MuiAccordionSummary-root.Mui-expanded': {
        minHeight: 'fit-content',
        margin: '0px'
      },
      '& .MuiAccordionSummary-content.Mui-expanded': {
        margin: '10px 0px'
      }
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      '& .count': {
        backgroundColor: colors.color13,
        borderRadius: '50%',
        color: colors.color5,
        width: '25px',
        height: '25px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }
  }
}

export { useStyles }
